var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hall-fluency",class:'fluency-level-' + _vm.fluencyLevel},[_vm._l((_vm.max),function(item,index){return _c('i',{key:index,staticClass:"fluency-item",class:{ active: index <= _vm.fluencyLevel - 1 }})}),_c('span',{staticClass:"fluency-desc"},[_vm._v(_vm._s(_vm.fluencyDesc))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }